import { render } from "./TheLogistikListe.vue?vue&type=template&id=db73c3c4&scoped=true"
import script from "./TheLogistikListe.vue?vue&type=script&lang=js"
export * from "./TheLogistikListe.vue?vue&type=script&lang=js"

import "./TheLogistikListe.vue?vue&type=style&index=0&id=db73c3c4&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db73c3c4"]])

export default __exports__